import { render, staticRenderFns } from "./home.vue?vue&type=template&id=9f6b580c"
import script from "./home.ts?vue&type=script&lang=js&external"
export * from "./home.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f6b580c')) {
      api.createRecord('9f6b580c', component.options)
    } else {
      api.reload('9f6b580c', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=9f6b580c", function () {
      api.rerender('9f6b580c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/home.vue"
export default component.exports